/**
 * Un solo reloj (§5.2): el del audio. Todo lo demás (metrónomo, resaltado, bucles) deriva su
 * posición de él. Estas interfaces permiten probar el transporte con un reloj simulado.
 */
export interface Clock {
  /** Segundos en la línea temporal del audio. */
  now(): number
}

export interface TimerHost {
  setInterval(callback: () => void, ms: number): unknown
  clearInterval(handle: unknown): void
}

export const browserTimers: TimerHost = {
  setInterval: (callback, ms) => window.setInterval(callback, ms),
  clearInterval: (handle) => window.clearInterval(handle as number),
}

/** Duración de un pulso en segundos. */
export function beatDuration(bpm: number): number {
  return 60 / bpm
}

/**
 * Instante del pulso n. Se calcula siempre desde el origen, nunca sumando duraciones, para
 * que el error de coma flotante no se acumule en una canción larga.
 */
export function beatTime(startTime: number, bpm: number, index: number): number {
  return startTime + index * beatDuration(bpm)
}

/** Posición en pulsos (con decimales) en un instante dado. Negativa antes del origen. */
export function beatPosition(startTime: number, bpm: number, time: number): number {
  return (time - startTime) / beatDuration(bpm)
}
